'use strict';

angular.module('mean.admin-panel').filter('builderAdminFilter', function ($filter) {
    return function (users) {
        var out = [];
        for(var i=0; i<users.length; i++) {
            if(users[i].roles.indexOf('builder') !== -1)
              out.push(users[i]);
            else if(users[i].roles.indexOf('purchasing_agent') !== -1)
              out.push(users[i]);
        }
        return out;
    };
});



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/filters/builder-users.js